var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { APP_STORE } from '@/stores/defs';
import { isObject } from 'lodash';
;
;
// TODO completed route and back routes can map to
// specific routes, and not be so stateful.
// _getCompletedRoute and _getBackRoute assume
// one route for now.
var navigationMixin = {
    computed: __assign({}, mapGetters({
        _getCompletedRoute: APP_STORE.GET_COMPLETED_ROUTE,
        _getBackRoute: APP_STORE.GET_BACK_ROUTE,
    }), { _hasCompletedRoute: function () {
            if (this._getCompletedRoute) {
                return true;
            }
            return false;
        },
        _hasBackRoute: function () {
            if (this._getBackRoute) {
                return true;
            }
            return false;
        } }),
    methods: __assign({}, mapActions({
        _setCompletedRoute: APP_STORE.SET_COMPLETED_ROUTE,
        _setBackRoute: APP_STORE.SET_BACK_ROUTE,
    }), { replaceRoute: function (routeName) {
            if (isObject(routeName)) {
                var name_1 = routeName.name, params = routeName.params;
                this.$router.replace({ name: name_1, params: params });
                return;
            }
            this.$router.replace({
                name: routeName,
            });
        },
        pushToRoute: function (routeName) {
            if (isObject(routeName)) {
                var name_2 = routeName.name, params = routeName.params;
                this.$router.push({ name: name_2, params: params });
                return;
            }
            this.$router.push({
                name: routeName,
            });
        },
        goToRoute: function (routeName) {
            if (isObject(routeName)) {
                var name_3 = routeName.name, params = routeName.params;
                this.$router.go({ name: name_3, params: params });
                return;
            }
            this.$router.go({
                name: routeName,
            });
        },
        _navigateToRouteObject: function (route) {
            // TODO validate here
            this.$router.push(route);
        },
        _navigateToPin: function () {
            this.replaceRoute('account-enter-pin');
        },
        _navigateToSignUp: function () {
            this.replaceRoute('account-sign-up');
        },
        _navigateToSignIn: function () {
            this.pushToRoute('account-sign-in');
        },
        _navigateToGuestForm: function () {
            this.replaceRoute('account-guest-form');
        },
        _navigateToPaymentChooser: function () {
            this.pushToRoute('payment-method');
        },
        _navigateToHome: function () {
            this.pushToRoute('home');
        },
        _navigateToCheckout: function () {
            this.pushToRoute('checkout');
        },
        _navigateToLocator: function () {
            this.pushToRoute('locator');
        },
        _navigateToServiceChooser: function () {
            this.pushToRoute('service');
        },
        _navigateToGreeting: function () {
            this.pushToRoute('greeting');
        },
        _navigateToItem: function (itemRoute) {
            this._setBackRoute(null);
            this._setCompletedRoute(null);
            this.$router.push(itemRoute);
        },
        _navigateBack: function () {
            var backRoute = this._getBackRoute;
            // TODO replace checkout router index object, hack needed for now.
            var backRouteName = backRoute && backRoute.name;
            if (backRouteName === 'checkout') {
                backRoute = null;
            }
            if (!backRoute) {
                this.$router.go(-1);
                return;
            }
            this.pushToRoute(backRoute);
            this._setBackRoute(null);
            this._setCompletedRoute(null);
        },
        _navigateToCompletedRoute: function () {
            if (!this._hasCompletedRoute) {
                console.warn('no completed route');
                return;
            }
            var route = this._getCompletedRoute;
            this.pushToRoute(route);
            this._setCompletedRoute(null);
            this._setBackRoute(null);
        } }),
};
export default navigationMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/navigationMixin.ts
// module id = G+Rd
// module chunks = 18